import React, { Suspense } from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';

import {
    tokenQueueList,
} from '../constants/constants';
import PageLoader from '../components/PageLoader/PageLoader';

const TokenMainContainer = React.lazy(() => import('../containers/TokenMainContainer/TokenMainContainer'));
const TokenQueuePage = React.lazy(() => import('../pages/TokenPage/TokenQueuePage'));

const TokenRoutes = props => (
    <TokenMainContainer history={props.history} match={props.match}>
        <Suspense fallback={<PageLoader />}>
            <Route path={tokenQueueList} exact component={TokenQueuePage} />
        </Suspense>
    </TokenMainContainer>
);

TokenRoutes.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object.isRequired,
};

TokenRoutes.defaultProps = {
    history: {},
};

export default TokenRoutes;
